import React from 'react';
export const Connections = () => {
  // να βαλω να φτιαχνω συνδεσεις, και να φαινονται ανα πολους, λουκια κτλ
  return <>Σε Εξέλιξη</>;
};
